export default __webpack_public_path__ + "bea9f963ac7c52d3f78b7e5ccac8cf18.png";